import { PortableTextBlock } from '@portabletext/react';
import clsx from 'clsx';
import { isValidElement, useContext } from 'react';
import { twMerge } from 'tailwind-merge';

import CustomPortableText from '../CustomPortableText';
import { LocaleContext } from '../Layout';

const PageSpecificDisclaimer = ({ pageDisclaimer }: { pageDisclaimer?: PortableTextBlock | PortableTextBlock[] }) => {
  if (!pageDisclaimer) return null;

  return (
    <div
      className={twMerge(
        'text-grey-100 [&_*]:mb-12 [&_*]:!text-xs md:[&_*]:!leading-gripped [&_p:last-of-type]:mb-0',
        '[&_a:hover]:underline [&_a]:font-bold [&_a]:text-grey-100 [&_a]:underline-offset-4',
      )}
    >
      <CustomPortableText content={pageDisclaimer} />
    </div>
  );
};

export const Disclaimers = ({
  footerDisclaimers,
  pageDisclaimer,
  searchParams,
}: {
  footerDisclaimers:
    | {
        disclaimersColumn: {
          en: PortableTextBlock | PortableTextBlock[];
          fr: PortableTextBlock | PortableTextBlock[];
        }[];
      }[]
    | null;
  pageDisclaimer?: PortableTextBlock | PortableTextBlock[];
  searchParams: string;
}) => {
  const locale = useContext(LocaleContext);

  const additionalDisclaimer = <PageSpecificDisclaimer pageDisclaimer={pageDisclaimer} />;
  const disclaimers = footerDisclaimers
    ? footerDisclaimers.map(({ disclaimersColumn }, i) => {
        const translatedDisclaimers = disclaimersColumn.map((disclaimer) => disclaimer[locale]);
        return i === 0 && pageDisclaimer ? [...translatedDisclaimers, additionalDisclaimer] : translatedDisclaimers;
      })
    : [[additionalDisclaimer]];

  if (!disclaimers || disclaimers.length === 0) return null;

  return (
    <div className="flex flex-col gap-32 border-t border-primary-350 pt-32 md:flex-row">
      {disclaimers.map((disclaimerColumn, i) => (
        <div
          key={i}
          className={twMerge(clsx('flex flex-1 flex-col gap-12', i === disclaimers.length - 1 && 'md:text-right'))}
        >
          {disclaimerColumn.map((disclaimer, index) => (
            <div
              key={index}
              className={twMerge(!!pageDisclaimer && index !== 0 && i === 0 && 'last:mt-24 md:last:mt-48')}
            >
              {isValidElement(disclaimer) ? (
                disclaimer
              ) : (
                <div className="[&_*]:text-xs [&_*]:text-grey-100 [&_a]:font-bold [&_a]:text-inherit [&_a]:underline-offset-4 [&_a]:hover:text-inherit">
                  <CustomPortableText content={disclaimer as PortableTextBlock} linkParams={searchParams} />
                </div>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
